<template>

  <div>
    <v-layout fluid>

      <v-slider
        :label="point_label" v-model="point"
        :min="point_min" :max="point_max">
      </v-slider>

      <!-- Reset chart zoom -->
      <v-tooltip bottom open-delay="600ms" style="z-index: 200;">
        <template #activator="{ on }">
          <v-btn icon ref="btnChartReset" @click="btnChartReset_click" v-on="on">
            <v-icon>mdi-magnify-scan</v-icon>
          </v-btn>
        </template>
        <span>Reset chart zoom</span>
      </v-tooltip>

      <!-- Copy to clipboard -->
      <v-tooltip bottom open-delay="600ms" style="z-index: 200;">
        <template #activator="{ on }">
          <v-btn
            icon v-on="on" ref="btnToClipboard"
            @click="btnToClipboard_click"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <template #default>
          <span>Copy raw data to clipboard</span>
        </template>
      </v-tooltip>

    </v-layout>

    <plate-raw-chart
      ref="chartRaw" style="min-height: 600px;"
      :plate="plate" :disabled="disabled"
      :selected_wells="selected_wells"
      :point="point-1"
      :hovered_well="hovered_well"
    >
    </plate-raw-chart>

    <div style="background-color: #AAFFAA; text-align: center;">
      bottom border of Raw
    </div>

  </div>


</template>

<script>

	import {mdiMagnifyScan} from '@mdi/js'

	import format from 'string-format'
	import {
		VLayout,
		VCard, VCardTitle, VCardText,
		VBtn, VSlider,
	} from 'vuetify'
	import PlateRawChart from "./charts/PlateRawChart"

	export default {
		name: "plate-raw",
		components: {
			VCard, VCardTitle, VCardText,
			VSlider,
			'plate-raw-chart': PlateRawChart
		},

		data: function () {
			return {
				point: -1,

				// txtToClipboard: "Text to clipboard 23 fg g w",
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Object, defualt: () => null,},
			selected_wells: {type: Array, default: () => [],},
			hovered_well: {type: Number, default: -1,},
		},

		watch: {
			plate: function (new_value, old_value) {
				if (new_value != old_value) {
					this.point = this.plate
						? this.plate.points.length
						: -1
				}
			},

			selected_wells: function () {
				const k = 3
			}
		},

		computed: {
			point_label: function () {
				return format("Cycle {0}", this.point)
			},

			point_min: function () {
				return 1
			},

			point_max: function () {
				return this.plate
					? this.plate.points.length
					: 1
			},
		},

		methods: {

			// -- Handle controls' events --

			btnChartReset_click: function (event) {
				this.$refs.chartRaw.reset()

				this.point = this.plate
					? this.plate.points.length
					: -1
			},

			btnToClipboard_click: function (event) {
				this.$copyText(this.$refs.chartRaw.txtToClipboard)
			},
		}
	}
</script>

<style scoped>

</style>